import { AnyProfile, ProfileType } from '@modules/search/types'

export enum AlertFrequencyType {
  NO_NOTIFICATION = 'NO_NOTIFICATION',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}

export interface ProfileAlert {
  id: AnyProfile['id']
  type: ProfileType
  alertFrequency?: AlertFrequencyType
  lastViewedAt?: string
  searchDocId?: AnyProfile['id']
  hasNewActivity?: boolean
  lastTrackedAt?: string
}
